export default __webpack_public_path__ + "static/media/evaluation.a6bb4e3a.svg";